import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store, configureAmplify } from "configs";
import App from "./App";
import utc from "dayjs/plugin/utc";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "./index.css";

dayjs.extend(utc);
dayjs.extend(isBetween);

configureAmplify();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30,
    },
  },
});

root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <App />
    </QueryClientProvider>
  </Provider>,
);
